module.exports = __webpack_public_path__ + "static/ig_banner_04-7cf8bb9ae5c196020707879ab69ca01b.png";